const API_KEY = process.env.REACT_APP_WEATHER_API_KEY;
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchWeatherData = async (city) => {
  if (!API_KEY) {
    throw new Error("API key is not configured");
  }

  const url = `${BASE_URL}/weather?q=${city}&appid=${API_KEY}&units=metric`;

  try {
    const response = await fetch(url);
    const data = await response.json();

    if (data.cod === 401) {
      throw new Error("Invalid API key");
    }

    if (data.cod === "404") {
      throw new Error(`City "${city}" not found`);
    }

    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch weather");
    }

    return data;
  } catch (error) {
    console.error("Weather API Error:", error);
    throw error;
  }
};

export const fetchForecastData = async (city) => {
  if (!API_KEY) {
    throw new Error("API key is not configured");
  }

  const url = `${BASE_URL}/forecast?q=${city}&appid=${API_KEY}&units=metric`;

  try {
    const response = await fetch(url);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch forecast");
    }

    return data;
  } catch (error) {
    console.error("Forecast API Error:", error);
    throw error;
  }
};

export const getWeatherIcon = (iconCode) => {
  return `https://openweathermap.org/img/wn/${iconCode}@2x.png`;
};
